export const formatLocation = (value: string): string =>
  value.replace(/([A-Z])/g, ' $1').trim();

export const formatUsTime = (slot: string): string => {
  const [hours, minutes] = slot.split(':').slice(0, 2).map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
};
